import {useApp} from "../../app.context";
import LocalizationInput from "../../elements/localizationInput.element";
import LocalizationTextArea from "../../elements/localizationTextArea.element";
import Collapsible from "../../elements/collapsible";
import {useRef, useState} from "react";

const WARNINGS_OPEN_KEY = 'notification-warnings-open';

function NotificationView() {
    const {notification, setNotification, getLocalizationValue} = useApp();

    // Persisted across sessions; defaults to open on first use.
    const [warningsOpen, setWarningsOpen] = useState<boolean>(() => {
        const stored = localStorage.getItem(WARNINGS_OPEN_KEY);
        return stored === null ? true : stored === 'true';
    });

    function setWarningsOpenPersisted(open: boolean) {
        setWarningsOpen(open);
        localStorage.setItem(WARNINGS_OPEN_KEY, String(open));
    }

    // Close-on-click-outside, but only when both press AND release land on
    // the overlay backdrop itself. Without the press-tracking, dragging a
    // text selection from inside the dialog out onto the backdrop would
    // close it on mouseup — annoying when the user is just trying to copy
    // text. mousedown originating on a child sets downedOnOverlay = false,
    // so the subsequent mouseup is ignored.
    const downedOnOverlay = useRef(false);
    function onOverlayMouseDown(e: React.MouseEvent) {
        downedOnOverlay.current = e.target === e.currentTarget;
    }
    function onOverlayMouseUp(e: React.MouseEvent) {
        const closing = downedOnOverlay.current && e.target === e.currentTarget;
        downedOnOverlay.current = false;
        if (closing) setNotification(undefined);
    }

    if (notification?.edit === true) {
        return (
            <div className={'layout vertical overlay notification-overlay'}
                 onMouseDown={onOverlayMouseDown} onMouseUp={onOverlayMouseUp}>
                <div className={'layout vertical gap box'} style={{padding: 10, gap: 10, width: 400}}
                     onClick={e => e.stopPropagation()}
                >
                    <div className={'layout horizontal gap-10'}>
                        <LocalizationInput id={notification?.title ?? ''} style={{flexGrow: 1}}/>
                        {notification.headerRight}
                    </div>
                    <LocalizationTextArea id={notification?.message ?? ''} style={{height: '100px'}}/>
                    <button onClick={() => setNotification(undefined)}>Okay!</button>
                </div>
            </div>
        )
    } else {
        const warnings = notification?.warnings ?? [];
        return (
            <div className={'layout vertical overlay notification-overlay'}
                 onMouseDown={onOverlayMouseDown} onMouseUp={onOverlayMouseUp}>
                <div className={'layout vertical gap box'} style={{padding: 10, gap: 10, width: 400}}
                     onClick={e => e.stopPropagation()}
                >
                    <p className={'text header'}>{getLocalizationValue(notification?.title ?? '')}</p>
                    <p style={{whiteSpace: 'pre-wrap'}}>{getLocalizationValue(notification?.message ?? '')}</p>
                    {warnings.length > 0 && (
                        <Collapsible
                            open={warningsOpen}
                            onOpenChange={setWarningsOpenPersisted}
                            title={<span style={{fontSize: 14, fontWeight: 600, color: 'white'}}>{`Warnings (${warnings.length})`}</span>}
                        >
                            <div className={'layout vertical gap'} style={{maxHeight: '6lh', overflowY: 'auto', marginTop: 6}}>
                                {warnings.map((w, i) => (
                                    <p key={i} style={{whiteSpace: 'pre-wrap', margin: 0}}>{w}</p>
                                ))}
                            </div>
                        </Collapsible>
                    )}
                    <button onClick={() => setNotification(undefined)}>Close</button>
                </div>
            </div>
        )
    }
}

export default NotificationView;
